import { Quote } from 'lucide-react';
import { testimonials } from '../mock';

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-[50px]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-14">
          <p className="reveal font-hand text-[26px] md:text-[30px] mb-2" style={{ color: 'var(--terracotta-deep)' }}>
            kind words
          </p>
          <h2 className="reveal reveal-delay-1 font-display text-[34px] md:text-[48px] leading-tight" style={{ color: 'var(--ink)' }}>
            People I&apos;ve worked with…
            <span className="italic block md:inline" style={{ color: 'var(--sage)' }}> …say the nicest things</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-7">
          {testimonials.map((t, i) => (
            <article
              key={t.name}
              className={`reveal reveal-delay-${i + 1} relative p-8 md:p-10 rounded-[22px]`}
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--border)',
              }}
            >
              <Quote size={28} style={{ color: 'var(--terracotta)' }} className="opacity-70" />
              <p className="mt-5 text-[16px] md:text-[17px] leading-[1.75]" style={{ color: 'var(--ink)' }}>
                “{t.quote}”
              </p>
              <div className="mt-7 pt-6 flex items-center gap-4" style={{ borderTop: '1px solid var(--border)' }}>
                <div
                  className="w-11 h-11 rounded-full flex items-center justify-center font-display text-[18px]"
                  style={{ background: 'linear-gradient(135deg, #C4622D, #D4A853)', color: '#FAF6EE' }}
                >
                  {t.name.split(' ').map((n) => n[0]).join('').slice(0, 2)}
                </div>
                <div>
                  <p className="font-display text-[20px] leading-none" style={{ color: 'var(--ink)' }}>{t.name}</p>
                  <p className="text-[12.5px] tracking-[0.1em] uppercase mt-1.5" style={{ color: 'var(--ink-soft)' }}>{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
